import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "defaultValue", "placeholder", "value", "onChange", "min", "max", "error", "errorMessage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import clsx from 'clsx';
import { isNumber } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ErrorView = function ErrorView(props) {
  var error = props.error,
      errorMessage = props.errorMessage,
      className = props.className;

  if (!error || !errorMessage) {
    return null;
  }

  return /*#__PURE__*/_jsx("p", {
    className: clsx('text-red-error mt-2 text-xs font-bold', className),
    children: errorMessage
  });
};

export var NumberInput = function NumberInput(props) {
  var className = props.className,
      defaultValue = props.defaultValue,
      placeholder = props.placeholder,
      value = props.value,
      onChange = props.onChange,
      min = props.min,
      max = props.max,
      error = props.error,
      errorMessage = props.errorMessage,
      extraProps = _objectWithoutProperties(props, _excluded);

  var _useState = useState(value === undefined || value === null ? undefined : value),
      inputValue = _useState[0],
      setInputValue = _useState[1];
  /**
   * methods
   */


  var inputChangeAction = function inputChangeAction(e) {
    var num = Number(e.target.value || 0);
    setInputValue(num);
    onChange === null || onChange === void 0 ? void 0 : onChange(num);
  };

  var blurChangeAction = function blurChangeAction() {
    var num = Number(inputValue);

    if (isNumber(min)) {
      if (num < min) {
        num = min;
      }
    }

    if (isNumber(max)) {
      if (num > max) {
        num = max;
      }
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(num);
    setInputValue(num);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
      className: clsx('block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6', className)
    }, extraProps), {}, {
      defaultValue: inputValue,
      type: "number",
      placeholder: placeholder,
      value: inputValue,
      onBlur: blurChangeAction,
      onChange: inputChangeAction
    })), error && /*#__PURE__*/_jsx(ErrorView, {
      error: error,
      errorMessage: errorMessage
    })]
  });
};